// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3Zo-T","label":"Completed_label__2GC0-"};